<template>
  <v-card>
    <v-card-title>{{ $t('pages.transfers.title') }}</v-card-title>
    <v-card-text>
      <wallet></wallet>
    </v-card-text>
    <transfer-table
      :page="page"
      @filterUpdated="data => onFilterUpdated(data)">
    </transfer-table>
  </v-card>
</template>

<script>
  import Utils from '@/utils/default'
  import TransferTable from '@/components/TransferTable.vue'
  import Wallet from '@/components/Wallet.vue'
  export default {
    components: {
      TransferTable,
      Wallet
    },
    props: {
      page: {
        type: Number,
        default: 1
      }
    },
    methods: {
      onFilterUpdated (filter) {
        this.$router.push({
          ...this.$route,
          query: Utils.dataForUrl(filter)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Transfers.vue